import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as Flash from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Actions from './actions'
import * as Constants from './constants'

const filterGroupsFilterSelector: IsActive.FilterSelector = (state: ApplicationState) => state.filterGroups.view.filter

export const epic = ReduxObservable.combineEpics(
  Flash.createFlashSuccessEpic(Constants.ADD_FILTER_GROUP, 'Filter Group added'),
  IsActive.createFilterAddedEpic(Constants.ADD_FILTER_GROUP, Actions.fetchFilterGroups, filterGroupsFilterSelector),
  IsActive.createFilterChangeEpic(Constants.FETCH_FILTER_GROUPS,
    Actions.fetchFilterGroups, filterGroupsFilterSelector),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_FILTERGROUPS_URL,
    Actions.fetchFilterGroups, filterGroupsFilterSelector),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_FILTER_GROUP_INLINE, Actions.updateStatus),
)



// WEBPACK FOOTER //
// ./src/pages/filter-groups/epic.ts